import React, { Component } from "react";
import {
  Row,
  Col,
  Form,
  Button,
  Card,
  Input,
  message,
  Select,
  Spin,
} from "antd";
import axios from "services/axios";

const FormItem = Form.Item;
const { Option } = Select;

class PricingAreaCreate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bohUsers: [],
      pricingAreas: [],
      isLoading: false,
    };
  }

  componentDidMount() {
    this.fetchAreaPricing();
    this.fetchBOH();
  }

  async fetchAreaPricing() {
    const {
      data: { areas },
    } = await axios.get(`/misc/area-pricing`);
    this.setState({ pricingAreas: areas });
  }

  async fetchBOH() {
    const {
      data: { bohUsers },
    } = await axios.get(`/misc/boh-users`);
    this.setState({ bohUsers });
  }

  async createPricingArea(e) {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      this.setState({ isLoading: true });
      if (!err) {
        axios
          .post(`/admin-panel/pricing-area`, values)
          .then(result => {
            message.success(`Berhasil menambah Area ${values.name}`);
            this.props.history.push(`/home/pricing-area`);
          })
          .catch(err => {
            this.errorMessage(err);
          });
      }
      this.setState({ isLoading: false });
    });
  }

  callback(key, props) {
    props.form.resetFields();
  }

  errorMessage(e) {
    if (e.response) {
      if (e.response.data || e.response.message) {
        message.error(
          e.response.data.message || e.response.message || e.response.data
        );
      } else {
        message.error("Error Create Area");
      }
    } else {
      message.error("Error Create Area");
    }
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Card title="Create Pricing Area">
        <Spin
          tip="Sedang menambahkan Area Baru"
          spinning={this.state.isLoading}>
          <Form onSubmit={e => this.createPricingArea(e)}>
            <FormItem label="Area">
              {getFieldDecorator("name", {
                rules: [{ required: true, message: "Area wajib diisi" }],
              })(<Input />)}
            </FormItem>
            <FormItem label="Plat Nomor">
              {getFieldDecorator("kodePlat", {
                rules: [{ required: true, message: "Kode Plat wajib diisi" }],
              })(<Input />)}
            </FormItem>
            <FormItem label="Disable Approval">
              {getFieldDecorator("isDisabled", {
                rules: [
                  { required: true, message: "Disable Approval wajib diisi" },
                ],
              })(
                <Select
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  placeholder="Select a Disable Approval">
                  {[false, true].map((val, index) => (
                    <Option key={index} value={val}>
                      {val ? "ON" : "OFF"}
                    </Option>
                  ))}
                </Select>
              )}
            </FormItem>
            <Row type="flex" justify="end">
              <Col>
                <Button htmlType="submit" type="primary">
                  Create
                </Button>
              </Col>
            </Row>
          </Form>
        </Spin>
      </Card>
    );
  }
}

export default Form.create()(PricingAreaCreate);



// WEBPACK FOOTER //
// src/components/Dashboard/Area/PricingArea/PricingAreaCreate.js